import {combineReducers} from 'redux';

function active(state = [], action) {
  switch (action.type) {
    case 'FETCH_EXPERIMENTS_SUCCESS':
      return action.data;
    default:
      return state;
  }
}

export default combineReducers({
  active
});



// WEBPACK FOOTER //
// ./reducers/experiments.js